import { render, staticRenderFns } from "./NuovoModifica.vue?vue&type=template&id=d2eec41e&scoped=true&"
import script from "./NuovoModifica.vue?vue&type=script&lang=js&"
export * from "./NuovoModifica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2eec41e",
  null
  
)

export default component.exports